import type { AppSettings } from '@gpa-scales/shared-types';
import { GradingScale, TermStructure, ResidencyStatus } from '@gpa-scales/shared-types';
import { LETTER_GRADE_POINTS_PLUS_MINUS } from '@gpa-scales/shared-logic/data/gradePointMappings';
import type { StateCreator } from 'zustand';

const DEFAULT_SETTINGS: AppSettings = {
  gradingScale: GradingScale.Scale4,
  termStructure: TermStructure.Semester,
  plusMinusEnabled: true,
  residencyStatus: ResidencyStatus.CaliforniaResident,
  roundingRule: { mode: 'decimal_2', method: 'round_half_up' },
  gradeScaleMap: LETTER_GRADE_POINTS_PLUS_MINUS,
  homeschoolMode: false,
};

export interface SettingsSlice {
  settings: AppSettings;
  updateSettings: (updates: Partial<AppSettings>) => void;
  resetSettings: () => void;
  loadSettings: (settings: AppSettings) => void;
}

export const createSettingsSlice: StateCreator<SettingsSlice> = (set) => ({
  settings: { ...DEFAULT_SETTINGS },
  updateSettings: (updates) =>
    set((state) => ({
      settings: { ...state.settings, ...updates },
    })),
  resetSettings: () => set({ settings: { ...DEFAULT_SETTINGS } }),
  loadSettings: (settings) => set({ settings }),
});
